import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SEO from '../components/common/SEO';
import { useHydrated } from '../hooks/useHydrated';
import { useTranslation } from '../hooks/useTranslation';
import { hinduFestivalTamil } from '../data/festivalTamil';
import './HinduFestivals.css';

const festivalData = [
  {
    month: 'January',
    festivals: [
      { date: 'Jan 3', name: 'Paush Purnima', type: 'Purnima' },
      { date: 'Jan 6', name: 'Sankashti Chaturthi', type: 'Vrat' },
      { date: 'Jan 14', name: 'Makar Sankranti / Pongal', type: 'Major' },
      { date: 'Jan 18', name: 'Mauni Amavasya', type: 'Amavasya' },
      { date: 'Jan 23', name: 'Vasant Panchami (Saraswati Puja)', type: 'Major' },
      { date: 'Jan 25', name: 'Ratha Saptami', type: 'Festival' },
      { date: 'Jan 26', name: 'Bhishma Ashtami', type: 'Festival' },
      { date: 'Jan 29', name: 'Jaya Ekadashi', type: 'Ekadashi' },
    ],
  },
  {
    month: 'February',
    festivals: [
      { date: 'Feb 1', name: 'Magha Purnima', type: 'Purnima' },
      { date: 'Feb 5', name: 'Sankashti Chaturthi', type: 'Vrat' },
      { date: 'Feb 13', name: 'Vijaya Ekadashi', type: 'Ekadashi' },
      { date: 'Feb 15', name: 'Maha Shivaratri', type: 'Major' },
      { date: 'Feb 17', name: 'Phalguna Amavasya', type: 'Amavasya' },
      { date: 'Feb 27', name: 'Amalaki Ekadashi', type: 'Ekadashi' },
    ],
  },
  {
    month: 'March',
    festivals: [
      { date: 'Mar 3', name: 'Phalguna Purnima', type: 'Purnima' },
      { date: 'Mar 3', name: 'Holika Dahan', type: 'Major' },
      { date: 'Mar 4', name: 'Holi (Dhulandi)', type: 'Major' },
      { date: 'Mar 11', name: 'Sheetala Ashtami', type: 'Festival' },
      { date: 'Mar 15', name: 'Papmochani Ekadashi', type: 'Ekadashi' },
      { date: 'Mar 18', name: 'Chaitra Amavasya', type: 'Amavasya' },
      { date: 'Mar 19', name: 'Chaitra Navratri / Ugadi / Gudi Padwa', type: 'Major' },
      { date: 'Mar 21', name: 'Gauri Puja / Gangaur', type: 'Festival' },
      { date: 'Mar 27', name: 'Rama Navami', type: 'Major' },
      { date: 'Mar 29', name: 'Kamada Ekadashi', type: 'Ekadashi' },
    ],
  },
  {
    month: 'April',
    festivals: [
      { date: 'Apr 2', name: 'Chaitra Purnima', type: 'Purnima' },
      { date: 'Apr 2', name: 'Hanuman Jayanti', type: 'Major' },
      { date: 'Apr 13', name: 'Varuthini Ekadashi', type: 'Ekadashi' },
      { date: 'Apr 17', name: 'Vaishakha Amavasya', type: 'Amavasya' },
      { date: 'Apr 20', name: 'Akshaya Tritiya', type: 'Major' },
      { date: 'Apr 27', name: 'Mohini Ekadashi', type: 'Ekadashi' },
    ],
  },
  {
    month: 'May',
    festivals: [
      { date: 'May 1', name: 'Vaishakha Purnima (Buddha Purnima)', type: 'Purnima' },
      { date: 'May 13', name: 'Apara Ekadashi', type: 'Ekadashi' },
      { date: 'May 16', name: 'Jyeshtha Amavasya (Shani Jayanti)', type: 'Amavasya' },
      { date: 'May 17', name: 'Adhik Maas Begins', type: 'Special' },
      { date: 'May 27', name: 'Padmini Ekadashi (Adhik)', type: 'Ekadashi' },
      { date: 'May 31', name: 'Jyeshtha Purnima', type: 'Purnima' },
    ],
  },
  {
    month: 'June',
    festivals: [
      { date: 'Jun 11', name: 'Parama Ekadashi (Adhik)', type: 'Ekadashi' },
      { date: 'Jun 15', name: 'Ashadha Amavasya (Adhik Maas Ends)', type: 'Amavasya' },
      { date: 'Jun 25', name: 'Nirjala Ekadashi', type: 'Ekadashi' },
      { date: 'Jun 29', name: 'Ashadha Purnima (Vat Purnima)', type: 'Purnima' },
    ],
  },
  {
    month: 'July',
    festivals: [
      { date: 'Jul 10', name: 'Yogini Ekadashi', type: 'Ekadashi' },
      { date: 'Jul 14', name: 'Shravana Amavasya', type: 'Amavasya' },
      { date: 'Jul 16', name: 'Jagannath Rath Yatra', type: 'Major' },
      { date: 'Jul 25', name: 'Devshayani Ekadashi (Chaturmas Begins)', type: 'Ekadashi' },
      { date: 'Jul 29', name: 'Shravana Purnima (Guru Purnima)', type: 'Purnima' },
    ],
  },
  {
    month: 'August',
    festivals: [
      { date: 'Aug 9', name: 'Kamika Ekadashi', type: 'Ekadashi' },
      { date: 'Aug 12', name: 'Bhadrapada Amavasya (Hariyali Amavasya)', type: 'Amavasya' },
      { date: 'Aug 18', name: 'Nag Panchami', type: 'Major' },
      { date: 'Aug 21', name: 'Varalakshmi Vratam', type: 'Vrat' },
      { date: 'Aug 23', name: 'Shravana Putrada Ekadashi', type: 'Ekadashi' },
      { date: 'Aug 28', name: 'Bhadrapada Purnima (Raksha Bandhan)', type: 'Purnima' },
    ],
  },
  {
    month: 'September',
    festivals: [
      { date: 'Sep 4', name: 'Janmashtami', type: 'Major' },
      { date: 'Sep 7', name: 'Aja Ekadashi', type: 'Ekadashi' },
      { date: 'Sep 11', name: 'Ashwin Amavasya (Bhadrapada Amavasya)', type: 'Amavasya' },
      { date: 'Sep 14', name: 'Ganesh Chaturthi', type: 'Major' },
      { date: 'Sep 22', name: 'Parivartini Ekadashi', type: 'Ekadashi' },
      { date: 'Sep 26', name: 'Ashwin Purnima', type: 'Purnima' },
      { date: 'Sep 27', name: 'Pitru Paksha Begins', type: 'Special' },
    ],
  },
  {
    month: 'October',
    festivals: [
      { date: 'Oct 6', name: 'Indira Ekadashi', type: 'Ekadashi' },
      { date: 'Oct 10', name: 'Mahalaya Amavasya (Pitru Paksha Ends)', type: 'Amavasya' },
      { date: 'Oct 12', name: 'Sharad Navratri Begins', type: 'Major' },
      { date: 'Oct 20', name: 'Dussehra (Vijayadashami)', type: 'Major' },
      { date: 'Oct 21', name: 'Papankusha Ekadashi', type: 'Ekadashi' },
      { date: 'Oct 26', name: 'Sharad Purnima', type: 'Purnima' },
      { date: 'Oct 29', name: 'Karwa Chauth', type: 'Vrat' },
    ],
  },
  {
    month: 'November',
    festivals: [
      { date: 'Nov 5', name: 'Rama Ekadashi', type: 'Ekadashi' },
      { date: 'Nov 6', name: 'Dhanteras', type: 'Major' },
      { date: 'Nov 8', name: 'Kartik Amavasya (Diwali)', type: 'Amavasya' },
      { date: 'Nov 8', name: 'Diwali (Lakshmi Puja)', type: 'Major' },
      { date: 'Nov 10', name: 'Govardhan Puja', type: 'Major' },
      { date: 'Nov 11', name: 'Bhai Dooj', type: 'Major' },
      { date: 'Nov 14', name: 'Chhath Puja', type: 'Major' },
      { date: 'Nov 20', name: 'Devutthana Ekadashi (Tulsi Vivah)', type: 'Ekadashi' },
      { date: 'Nov 24', name: 'Kartik Purnima', type: 'Purnima' },
    ],
  },
  {
    month: 'December',
    festivals: [
      { date: 'Dec 4', name: 'Utpanna Ekadashi', type: 'Ekadashi' },
      { date: 'Dec 8', name: 'Margashirsha Amavasya', type: 'Amavasya' },
      { date: 'Dec 19', name: 'Gita Jayanti', type: 'Major' },
      { date: 'Dec 20', name: 'Mokshada Ekadashi', type: 'Ekadashi' },
      { date: 'Dec 23', name: 'Margashirsha Purnima', type: 'Purnima' },
    ],
  },
];

const typeColors = {
  Major: '#e65100',
  Ekadashi: '#1565c0',
  Vrat: '#6a1b9a',
  Purnima: '#f9a825',
  Amavasya: '#37474f',
  Festival: '#2e7d32',
  Special: '#c62828',
};

const typeLabels = ['All', 'Major', 'Ekadashi', 'Vrat', 'Purnima', 'Amavasya', 'Festival', 'Special'];

const HinduFestivals = () => {
  const currentYear = new Date().getFullYear();
  const [filter, setFilter] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const hydrated = useHydrated();
  const { t, lang } = useTranslation();

  const tf = (name) => lang === 'ta' && hinduFestivalTamil[name] ? hinduFestivalTamil[name] : name;

  const typeTranslations = {
    All: t('hinduFestivals.all'),
    Major: t('hinduFestivals.major'),
    Ekadashi: t('hinduFestivals.ekadashi'),
    Vrat: t('hinduFestivals.vrat'),
    Purnima: t('hinduFestivals.purnima'),
    Amavasya: t('hinduFestivals.amavasya'),
    Festival: t('hinduFestivals.festivalType'),
    Special: t('hinduFestivals.special'),
  };

  const filteredData = festivalData
    .map((monthData) => ({
      ...monthData,
      festivals: monthData.festivals.filter((f) => {
        const matchesFilter = filter === 'All' || f.type === filter;
        const matchesSearch =
          f.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          f.date.toLowerCase().includes(searchTerm.toLowerCase());
        return matchesFilter && matchesSearch;
      }),
    }))
    .filter((monthData) => monthData.festivals.length > 0);

  const totalFestivals = filteredData.reduce((sum, m) => sum + m.festivals.length, 0);

  return (
    <div className="hindu-festivals-page">
      <SEO
        title={`Hindu Festivals ${currentYear} - Complete Calendar with Dates`}
        description={`Complete list of Hindu festivals in ${currentYear} with dates. Includes Diwali, Holi, Navratri, Janmashtami, Ganesh Chaturthi, Ekadashi, and all major Hindu festivals month-wise.`}
        keywords={`hindu festivals ${currentYear}, hindu calendar ${currentYear}, diwali ${currentYear}, holi ${currentYear}, navratri ${currentYear}, ekadashi ${currentYear}, hindu holidays ${currentYear}`}
        canonicalPath="/hindu-festivals"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "CollectionPage",
            "name": `Hindu Festivals ${currentYear} - Complete Calendar with Dates`,
            "description": `Complete list of Hindu festivals in ${currentYear} with dates. Includes Diwali, Holi, Navratri, Janmashtami, Ganesh Chaturthi, Ekadashi, and all major Hindu festivals month-wise.`,
            "url": "https://www.parithi.com/hindu-festivals",
          },
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            "mainEntity": [
              {
                "@type": "Question",
                "name": "Why do Hindu festival dates change every year?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Hindu festivals are determined by the lunisolar Panchang calendar, which is based on both the Moon\u2019s position (Tithi) and the Sun\u2019s position (Masa/month). Since this doesn\u2019t align perfectly with the 365-day Gregorian calendar, festival dates shift by 10-11 days each year. An Adhik Maas (leap month) is added approximately every 3 years to realign the calendars.",
                },
              },
              {
                "@type": "Question",
                "name": "What is the difference between Amanta and Purnimanta month systems?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "In the Amanta system (followed in South India, Gujarat, Maharashtra), the lunar month ends on Amavasya (new moon). In the Purnimanta system (North India), the month ends on Purnima (full moon). This means some festivals like Diwali, Holi, and Shivaratri fall in different months in these two systems, though the actual date (Tithi) remains the same.",
                },
              },
              {
                "@type": "Question",
                "name": "Which months are considered inauspicious for ceremonies?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Adhik Maas (the extra lunar month added every 3 years) and Mal Maas are considered inauspicious for weddings, griha pravesh, and sacred thread ceremonies. Additionally, the months of Ashada, Bhadrapada, and Karthik have specific restrictions. Regional traditions may vary \u2014 Tamil Panchangam has its own list of auspicious and inauspicious months.",
                },
              },
              {
                "@type": "Question",
                "name": "What is Ekadashi and why is it significant?",
                "acceptedAnswer": {
                  "@type": "Answer",
                  "text": "Ekadashi is the 11th lunar day (Tithi) of both the waxing (Shukla) and waning (Krishna) phases of the Moon, occurring twice a month. It is one of the most important Vrat (fasting) days in Hinduism, dedicated to Lord Vishnu. There are 24 Ekadashis in a year, each with a specific name and story. Fasting on Ekadashi is believed to cleanse sins and promote spiritual advancement.",
                },
              },
            ],
          },
        ]}
      />

      <div className="container">
        <motion.div
          className="page-header"
          initial={hydrated ? { opacity: 0, y: -20 } : false}
          animate={{ opacity: 1, y: 0 }}
        >
          <h1>
            {t('hinduFestivals.title')} <span className="gradient-text">{currentYear}</span>
          </h1>
          <p>{t('hinduFestivals.subtitle')}</p>
        </motion.div>

        {/* Adhik Maas Notice */}
        <motion.div
          className="adhik-maas-banner"
          initial={hydrated ? { opacity: 0, scale: 0.95 } : false}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ delay: 0.2 }}
        >
          <span className="adhik-maas-icon">&#9733;</span>
          <div>
            {lang === 'ta' ? (
              <><strong>அதிக மாதம் (கூடுதல் மாதம்)</strong> {currentYear}-ல்: மே 17 - ஜூன் 15. இது ரக்ஷா பந்தன் மற்றும் தீபாவளி போன்ற முக்கிய பண்டிகைகளை வழக்கமான ஆண்டுகளை விட கிட்டத்தட்ட 20 நாட்கள் மாற்றும்.</>
            ) : (
              <><strong>Adhik Maas (Extra Month)</strong> in {currentYear}: May 17 - June 15. This shifts major festivals like Raksha Bandhan and Diwali by nearly 20 days compared to usual years.</>
            )}
          </div>
        </motion.div>

        {/* Search and Filter */}
        <motion.div
          className="festivals-controls"
          initial={hydrated ? { opacity: 0, y: 10 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          <div className="festivals-search">
            <input
              type="text"
              placeholder={t('hinduFestivals.searchPlaceholder')}
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="festivals-search-input"
            />
          </div>
          <div className="festivals-filter-tags">
            {typeLabels.map((type) => (
              <button
                key={type}
                className={`filter-tag ${filter === type ? 'active' : ''}`}
                onClick={() => setFilter(type)}
                style={
                  filter === type && type !== 'All'
                    ? { background: typeColors[type], borderColor: typeColors[type], color: '#fff' }
                    : {}
                }
              >
                {typeTranslations[type]}
              </button>
            ))}
          </div>
          <div className="festivals-count">
            {t('hinduFestivals.showing')} {totalFestivals} {totalFestivals !== 1 ? t('hinduFestivals.festivals') : t('hinduFestivals.festival')}
          </div>
        </motion.div>

        {/* Festival Months */}
        <div className="festivals-grid">
          {filteredData.map((monthData, idx) => (
            <motion.div
              key={monthData.month}
              className="festival-month-card"
              initial={hydrated ? { opacity: 0, y: 20 } : false}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.1 * idx }}
            >
              <div className="month-header">
                <h2>{t(`months.${monthData.month}`)}</h2>
                <span className="month-count">{monthData.festivals.length} {t('hinduFestivals.festivals')}</span>
              </div>
              <div className="month-festivals">
                {monthData.festivals.map((festival, fIdx) => (
                  <div key={fIdx} className="festival-row">
                    <div className="festival-date">{festival.date.split(' ')[1]}</div>
                    <div className="festival-info">
                      <span className="festival-name">{tf(festival.name)}</span>
                      <span
                        className="festival-type-badge"
                        style={{ background: typeColors[festival.type] || '#757575' }}
                      >
                        {typeTranslations[festival.type] || festival.type}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>

        {filteredData.length === 0 && (
          <div className="no-results">
            <p>{t('hinduFestivals.noResults')}</p>
          </div>
        )}

        {/* Key Highlights */}
        <motion.div
          className="festivals-highlights"
          initial={hydrated ? { opacity: 0, y: 20 } : false}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.5 }}
        >
          <h2>{t('hinduFestivals.keyHighlights')} {currentYear}</h2>
          <div className="highlights-grid">
            <div className="highlight-card">
              <div className="highlight-icon">&#127774;</div>
              <h3>{t('hinduFestivals.hinduNewYear')}</h3>
              <p>March 19, {currentYear} - Vikram Samvat 2082 begins with Chaitra Navratri</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127769;</div>
              <h3>{t('hinduFestivals.adhikMaas')}</h3>
              <p>May 17 - June 15 - Extra month shifts many festivals by ~20 days</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127878;</div>
              <h3>{t('hinduFestivals.diwali')} {currentYear}</h3>
              <p>November 8, {currentYear} - Festival of Lights, Lakshmi Puja</p>
            </div>
            <div className="highlight-card">
              <div className="highlight-icon">&#127912;</div>
              <h3>{t('hinduFestivals.holi')} {currentYear}</h3>
              <p>March 4, {currentYear} - Festival of Colors</p>
            </div>
          </div>
        </motion.div>

        {/* Bottom SEO Content */}
        <div className="page-bottom-content">
          <h2>Complete Hindu Festival Calendar - Vrats, Puja & Auspicious Dates</h2>
          <p>Browse the complete month-wise Hindu festival calendar with accurate dates for all major festivals, vrats (fasts), and auspicious occasions. Our calendar covers Navratri, Diwali, Holi, Ganesh Chaturthi, Maha Shivaratri, Pongal, Raksha Bandhan, Janmashtami, and many more important Hindu observances throughout the year.</p>
          <p>Hindu festivals are calculated based on the lunisolar Panchang calendar, which follows both the Moon's phases (Tithi) and the Sun's movement through zodiac signs. This means festival dates change every year relative to the Gregorian calendar. Our festival calendar accounts for regional variations, Adhik Maas (extra month), and Amanta/Purnimant month systems to provide the most accurate dates for your celebrations.</p>

          <h3>Major Hindu Festivals and Their Significance</h3>
          <p><strong>Diwali (Deepavali):</strong> The festival of lights celebrated on Amavasya (new moon) of Kartik month, marking Lord Rama's return to Ayodhya and the victory of light over darkness. Lakshmi Puja is performed during Diwali night for wealth and prosperity. The five-day celebration includes Dhanteras, Naraka Chaturdashi, Lakshmi Puja, Govardhan Puja, and Bhai Dooj.</p>
          <p><strong>Navratri:</strong> Nine nights dedicated to the nine forms of Goddess Durga (Navadurga). Celebrated twice a year — Chaitra Navratri in spring and Shardiya Navratri in autumn. Each day of Navratri is associated with a specific form of the Goddess and corresponding color, food offering, and prayer ritual. Dussehra (Vijayadashami) on the 10th day marks the victory of good over evil.</p>
          <p><strong>Maha Shivaratri:</strong> The great night of Lord Shiva, observed on the 14th lunar day (Chaturdashi) of the Krishna Paksha in Phalguna month. Devotees fast, perform Rudrabhishek, and keep vigil through the night in four prahar (three-hour periods). It is considered the most auspicious night for Shiva worship and spiritual liberation.</p>
          <p><strong>Ganesh Chaturthi:</strong> Birthday of Lord Ganesha on the 4th day (Chaturthi) of Bhadrapada's Shukla Paksha. The 10-day festival culminates with Ganesh Visarjan (immersion) on Ananta Chaturdashi. Ganesha, the remover of obstacles, is worshipped before all Hindu ceremonies and new beginnings.</p>

          <h3>Regional Festival Variations Across India</h3>
          <p>Hindu festivals often have regional variations in date and celebration. Pongal (Tamil Nadu) coincides with Makar Sankranti and marks the Sun's entry into Capricorn. Onam (Kerala) celebrates the homecoming of King Mahabali during the Chingam month. Bihu (Assam), Baisakhi (Punjab), and Ugadi (Karnataka/Andhra) mark the regional New Year with harvest celebrations. Tamil festivals follow the Tamil solar calendar (Tamil Panchangam), while North Indian festivals primarily follow the lunar calendar. Our calendar provides dates for all these regional variations.</p>

          <h3>Frequently Asked Questions About Hindu Festivals</h3>
          <div className="faq-seo">
            <div className="faq-seo-item">
              <h4>Why do Hindu festival dates change every year?</h4>
              <p>Hindu festivals are determined by the lunisolar Panchang calendar, which is based on both the Moon's position (Tithi) and the Sun's position (Masa/month). Since this doesn't align perfectly with the 365-day Gregorian calendar, festival dates shift by 10-11 days each year. An Adhik Maas (leap month) is added approximately every 3 years to realign the calendars.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What is the difference between Amanta and Purnimanta month systems?</h4>
              <p>In the Amanta system (followed in South India, Gujarat, Maharashtra), the lunar month ends on Amavasya (new moon). In the Purnimanta system (North India), the month ends on Purnima (full moon). This means some festivals like Diwali, Holi, and Shivaratri fall in different months in these two systems, though the actual date (Tithi) remains the same.</p>
            </div>
            <div className="faq-seo-item">
              <h4>Which months are considered inauspicious for ceremonies?</h4>
              <p>Adhik Maas (the extra lunar month added every 3 years) and Mal Maas are considered inauspicious for weddings, griha pravesh, and sacred thread ceremonies. Additionally, the months of Ashada, Bhadrapada, and Karthik have specific restrictions. Regional traditions may vary — Tamil Panchangam has its own list of auspicious and inauspicious months.</p>
            </div>
            <div className="faq-seo-item">
              <h4>What is Ekadashi and why is it significant?</h4>
              <p>Ekadashi is the 11th lunar day (Tithi) of both the waxing (Shukla) and waning (Krishna) phases of the Moon, occurring twice a month. It is one of the most important Vrat (fasting) days in Hinduism, dedicated to Lord Vishnu. There are 24 Ekadashis in a year, each with a specific name and story. Fasting on Ekadashi is believed to cleanse sins and promote spiritual advancement.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HinduFestivals;
